import 'leaflet/dist/leaflet.css';
import { Select } from 'antd5';
import { MapContainer } from 'react-leaflet';
import styled, { css } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const StyledMap = styled(MapContainer)<{ $height?: string }>`
  width: 100%;
  height: ${props => (props.$height ? props.$height : '100%')};
  z-index: 1;
  position: relative;

  .turbine-svg-icon {
    background: transparent;
    border: none;
    overflow: visible !important;
  }

  .leaflet-popup-content-wrapper {
    border-radius: 8px;
  }

  .leaflet-tooltip {
    background: ${({ theme }) => theme.tooltipBackground};
    color: ${({ theme }) => theme.measurementTextColor};
    border: 1px solid ${({ theme }) => theme.borderAccentColor};
    box-shadow: 0 2px 6px ${({ theme }) => theme.darkShadow};
  }

  .custom-tooltip {
    background: transparent;
    border: none;
    box-shadow: none;
    margin: 16px 0 0 0;
    cursor: default;

    &:before {
      display: none;
    }
  }

  .leaflet-tooltip-top:before {
    border-top-color: ${({ theme }) => theme.tooltipBackground};
  }

  .leaflet-tooltip-bottom:before {
    border-bottom-color: ${({ theme }) => theme.tooltipBackground};
  }

  .leaflet-tooltip-left:before {
    border-left-color: ${({ theme }) => theme.tooltipBackground};
  }

  .leaflet-tooltip-right:before {
    border-right-color: ${({ theme }) => theme.tooltipBackground};
  }

  & .marker-cluster-small {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-small div {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-medium {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-medium div {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-large {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  & .marker-cluster-large div {
    background-color: ${({ theme }) => theme.tealLightOpacity};
  }

  ${({ theme }) =>
    theme.themeName === Theme.Dark
      ? css`
          .leaflet-popup-content-wrapper,
          .leaflet-popup-tip,
          .leaflet-control-layers {
            background-color: ${theme.tooltipBackground};
            color: ${theme.headerColor};
          }

          .leaflet-control-zoom-in,
          .leaflet-control-zoom-out {
            background-color: ${theme.buttonBackgroundColor};
            color: ${theme.headerColor};

            &:hover {
              background-color: ${theme.secondaryBackgroundColor};
            }

            &.leaflet-disabled {
              background-color: ${theme.disabledBackground};
              color: ${theme.disabledTextColor};
              cursor: not-allowed;
            }
          }
        `
      : ''}
`;

export const StyledSelect = styled(Select)`
  z-index: 1000;
  position: absolute !important;
  right: 0;
  margin: 0.25rem !important;
`;

// Map labels need basemap contrast: black on street, white on satellite
export const StyledText = styled.p<{ $isSatelliteView?: boolean }>`
  color: ${({ theme, $isSatelliteView }) =>
    $isSatelliteView ? theme.mapControlsIconColor : theme.mapPicturePinStroke};
  font-size: 14px;
  font-weight: 600;
`;
